<template>

<v-app>

  <MobileHeader 
    v-if="$vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly" :juba="juba"
  ></MobileHeader>
  <DesktopHeader v-else :juba="juba"></DesktopHeader>
  <!-- Sizes your content based upon application components -->

  <v-content>
   
      <router-view></router-view>
    
  </v-content>


</v-app>
</template>

<script

>

import DesktopHeader from "@/components/DesktopHeader";
import MobileHeader  from "@/components/MobileHeader";

//import AppFooter from "@/components/AppFooter"
import {mapState } from 'vuex';

export default {
  name: 'App',
  components: {
    DesktopHeader,
    MobileHeader
 
  },
  computed: {
    ...mapState({
        juba: "juba"

    })
  }
};
</script>
